<template>
  <div>

    <v-fade-transition mode="out-in">
      <v-alert 
        class="my-3"
        v-if="!loading && drawingHighlights.length == 0"
        type="info">
        There are no drawing highlights.
      </v-alert>

      <table
        v-if="loading || drawingHighlights.length > 0" 
        class="table is-fullwidth is-hoverable is-clickable has-smaller-font">
        <thead>
          <tr>
            <th v-for="(header, i) in headers" :key="i">
              {{ header }}
            </th>
          </tr>
          <tr v-if="loading">
            <th :colspan="headers.length" class="py-0 px-0 is-naked">
              <v-progress class="is-fullwidth" v-model="loading"/>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr 
            v-for="highlight in drawingHighlights" 
            :key="highlight.id"
            @click="viewDrawingHighlight(highlight)">
            <td>
              {{ highlight.project_rfq.project.project_name }}
            </td>
            <td>
              <div class="is-size-7">
                {{ highlight.project_rfq.rfq_name}}
              </div>
              <div class="help has-text-grey text--nowrap">
                Version {{ highlight.project_rfq.version }}
              </div>
            </td>
            <td>
              <div class="is-size-7">
                {{ highlight.created_user.display_name }}
              </div>
              <div class="help has-text-grey text--nowrap">
                {{ formatDate(parseDate(highlight.created_on)) }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </v-fade-transition>

    <v-pagination 
      class="mt-3"
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>
  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import VProgress from '@/components/base/VProgress'
import VAlert from '@/components/base/VAlert'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import { mapState, mapActions, mapMutations } from 'vuex'

import { parseJSON, format } from 'date-fns'

export default {
  props: {
    filters: {
      type: Object
    }
  },
  components: { VPagination, VProgress, VAlert, VFadeTransition },
  data() {
    return {
      headers: ['Project', 'RFQ Name & Version', 'Created By/ On'],
      parseDate: (date) => { return date ? parseJSON(date) : date },
      formatDate: (date) => format(date, "yyyy-MM-dd HH:mm")
    }
  },
  computed: {
    ...mapState("drawingHighlights", ["drawingHighlights", "loading", "pagination"])
  },
  watch: {
    'pagination.page'() {
      let params = { ...this.filters, ...this.pagination };
      params.simplified = true;
      this.getDrawingHighlights(params);
    },
    filters: {
      handler(filters) {
        let params = { ...filters };
        params.simplified = true;
        this.getDrawingHighlights(params);
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("drawingHighlights", ["getDrawingHighlights"]),
    ...mapMutations("drawingHighlights", ["changePage"]),
    initialize() {
      let params = { ...this.filters };
      params.simplified = true;
      this.getDrawingHighlights(params);
    },
    viewDrawingHighlight(highlight) {
      this.$router.push({
        name: 'DrawingHighlightViewer', 
        params: {
          drawingHighlightId: highlight.id,
          drawingHighlight: highlight
        } 
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>